<template>
  <div v-if="error" class="alert alert-danger alert-dismissible fade show monospaced" role="alert">
    <i class="fa-solid fa-bug"></i>
    {{ error }}
    <button type="button" class="btn-close" @click="$emit('clear')"></button>
  </div>
</template>

<script>
export default {
  name: 'ErrorDisplay',
  props: {
    error: {
      type: String,
      default: ''
    }
  }
}
</script>